// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"store_mainContainer__1vfHd","tabs":"store_tabs__3kdJH","tab":"store_tab__azwKC","active":"store_active__2Om8q"};